import { bookingManagementQueryKeys as e } from "./useManagementQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { bookingsApi as n } from "@maat/api-booking";
//#region src/management/useBookingsQuery.ts
var r = 50, i = (i, a) => t({
	queryKey: e.list(i),
	fetchPage: (e) => n.listBookings({
		...i,
		limit: r,
		offset: (e - 1) * r
	}),
	key: "bookings",
	enabled: a?.enabled ?? !0
});
//#endregion
export { i as useBookingsQuery };
